import {useTranslation} from 'react-i18next'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import './DateSelector.style.scss'

// Shared presentation only: each product retains its own date/request semantics.
const CompactDateSelector = ({
  canGoPrev, canGoNext, onPrev, onNext, onOpen, disabled,
  isCalendarOpen, isLoadingDates, triggerLabel, cloudinessFilter, onCloudinessChange,
}) => {
  const {t} = useTranslation()
  return (
    <div className="view-land-date-selector">
      <div className="view-land-date-selector__current">
        <button type="button" onClick={onPrev} disabled={!canGoPrev}
          className={`btn btn-icon btn-light view-land-date-selector__step ${!canGoPrev ? 'is-disabled' : ''}`.trim()}
          title={t('images:previous_date')} aria-label={t('images:previous_date')}>
          <KTSVG path="/media/icons/duotune/arrows/arr026.svg" className="svg-icon svg-icon-1x svg-icon-primary" />
        </button>
        <button type="button" onClick={onOpen} disabled={disabled}
          className="btn btn-light view-land-date-selector__trigger"
          aria-expanded={isCalendarOpen} aria-busy={isLoadingDates} aria-label={triggerLabel}>
          <span className="view-land-date-selector__trigger-copy" title={triggerLabel}>{triggerLabel}</span>
          {isLoadingDates ? (
            <span className="view-land-date-selector__loading-spinner" aria-hidden="true" />
          ) : (
            <KTSVG path="/media/icons/duotune/arrows/arr072.svg"
              className={`svg-icon svg-icon-5 view-land-date-selector__trigger-chevron ${isCalendarOpen ? 'is-open' : ''}`.trim()} />
          )}
        </button>
        <button type="button" onClick={onNext} disabled={!canGoNext}
          className={`btn btn-icon btn-light view-land-date-selector__step ${!canGoNext ? 'is-disabled' : ''}`.trim()}
          title={t('images:next_date')} aria-label={t('images:next_date')}>
          <KTSVG path="/media/icons/duotune/arrows/arr027.svg" className="svg-icon svg-icon-1x svg-icon-primary" />
        </button>
      </div>
      <div className="view-land-date-selector__filter">
        <span className="view-land-date-selector__filter-icon-wrap"
          aria-label={t('images:cloudiness_tooltip')} tabIndex={0}>
          <KTSVG path="/media/icons/duotune/files/fil020.svg"
            className="svg-icon svg-icon-2x svg-icon-primary view-land-date-selector__filter-icon" />
          <span className="view-land-date-selector__filter-tooltip" role="tooltip">{t('images:cloudiness_tooltip')}</span>
        </span>
        <span className="view-land-date-selector__filter-label">&le;</span>
        <input type="number" min="0" max="100" value={cloudinessFilter.toString()}
          aria-label={t('images:hd_dates.cloud_filter', {defaultValue: 'Nubosidad máxima'})}
          onChange={(event) => {
            let value = Number(event.target.value.replace(/^0+(?!$)/, ''))
            if (value < 0) value = 0
            else if (value > 100) value = 100
            onCloudinessChange(value)
          }} className="form-control view-land-date-selector__filter-input" />
        <span className="view-land-date-selector__filter-suffix">%</span>
      </div>
    </div>
  )
}

export default CompactDateSelector
